import { render, staticRenderFns } from "./detail_by_liveId.vue?vue&type=template&id=1137b1d7&"
import script from "./detail_by_liveId.vue?vue&type=script&lang=js&"
export * from "./detail_by_liveId.vue?vue&type=script&lang=js&"
import style0 from "./detail_by_liveId.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports